import { useEffect, useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { CenteredCard } from "@/components/CenteredCard";
import { oauthRequestState } from "@/features/oauth/request";
import { OAuthErrorDetails } from "@/features/oauth/error-details";
function Login() {
  const [request] = useState(() => oauthRequestState(window.location.search));
  useEffect(() => {
    if (request.query) window.location.replace("/auth/sign-in?next=%2Foauth%2Fresume");
  }, [request]);
  return (
    <CenteredCard title="Connect to TripBears" description={request.error ?? "Opening sign-in…"}>
      <OAuthErrorDetails error={request.failure} />
    </CenteredCard>
  );
}
export const Route = createFileRoute("/login")({ component: Login });
